import { color } from '../../../styles/GlobalStyles';

import {
  Box,
  Flexed,
  Pill,
  UserImageCircle
} from '../../../styles/GlobalComponents';

import { H3, H4, P3 } from '../../../styles/FontStyles';
import { User } from '../../../types/loginTypes';

export const TopSponsorPerformer = ({
  user,
  index
}: {
  user: User;
  index: number;
}) => {
  return (
    <Box border mb='8' mbSM='8' p='10px 20px' pSM='10px 15px'>
      <Flexed gap='5px' center>
        <Flexed center gap='10px' gapSM='10px'>
          <Flexed width='20px' widthSM='20px' end>
            <H3
              right
              style={{ textAlign: 'right' }}
              color={color.colors.primary900}>
              {index + 1}
            </H3>
          </Flexed>
          <UserImageCircle
            image={user?.profileImageUrl}
            name={user?.name}
            surname={user?.surname}
            size='40px'
            fontSize='16px'
            margin={'0 8px 0 0'}
          />
        </Flexed>
        <Flexed center between width='100%'>
          <div>
            <P3 className='truncated'>{user?.username}</P3>
          </div>

          <Flexed center>
            <Pill>
              <P3 bold fontFamily='Nulshock' color={color.colors.neutral0}>
                1
              </P3>
            </Pill>
          </Flexed>
        </Flexed>
      </Flexed>
    </Box>
  );
};
